<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/CRDataBase" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title">
      <div class="d-tabs d-flex">
        <div class="basic-information">Project Basic Information</div>
        <div class="d-row">
          <div class="d-flex">
            <label class="label">Project Code</label>
            <div class="value">{{ProjectBasicInformation.projectCode}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Status</label>
            <div class="value">{{ProjectBasicInformation.projectStatus}}</div>
          </div>
          <div class="d-flex">
            <label class="label">POS Name</label>
            <div class="value">{{ProjectBasicInformation.posFullNameCN}}</div>
          </div>
          <div class="d-flex">
            <label class="label">POS Address</label>
            <div class="value">{{ProjectBasicInformation.address}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Store Format</label>
            <div class="value">{{ProjectBasicInformation.format}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Action</label>
            <div class="value">{{ProjectBasicInformation.action}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Channel</label>
            <div class="value">{{ProjectBasicInformation.channel}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Sub Channel</label>
            <div class="value">{{ProjectBasicInformation.subChannel}}</div>
          </div>

          <div class="d-flex">
            <label class="label">Team</label>
            <div class="value">{{ProjectBasicInformation.team}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Region</label>
            <div class="value">{{ProjectBasicInformation.region}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Province</label>
            <div class="value">{{ProjectBasicInformation.provinceCN}}</div>
          </div>
          <div class="d-flex">
            <label class="label">City</label>
            <div class="value">{{ProjectBasicInformation.cityCN}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Group Customer</label>
            <div class="value">{{ProjectBasicInformation.groupCustomerName}}</div>
          </div>

          <div class="d-flex">
            <label class="label">Space</label>
            <div class="value">{{translateValue(ProjectBasicInformation.space)}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Apply Date</label>
            <div class="value">{{formateDate(ProjectBasicInformation.appDate)}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Estimate Open Date</label>
            <div class="value">{{formateDate(ProjectBasicInformation.requestOpenDate)}}</div>
          </div>
          <div class="d-flex">
            <label class="label">CR Submit Date</label>
            <div class="value">{{ProjectBasicInformation.crSubmitDate}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Financial Year</label>
            <div class="value">{{ProjectBasicInformation.financial_Year}}</div>
          </div>
        </div>
        <div class="d-row">
          <div class="d-flex">
            <label class="label">Capex CR</label>
            <div class="value">{{ProjectBasicInformation.capexCRNO}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Status</label>
            <div class="value">{{ProjectBasicInformation.capexCRStatus}}</div>
          </div>
          <div class="d-flex">
            <label class="label" style="width:35%;">Capex Total(w/ VAT)</label>
            <div class="value">{{translateValue(ProjectBasicInformation.capex)}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Digital CR</label>
            <div class="value">{{ProjectBasicInformation.digitalCRNO}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Status</label>
            <div class="value">{{ProjectBasicInformation.digitalCRStatus}}</div>
          </div>
          <div class="d-flex">
            <label class="label" style="width:35%;">Digital Total(w/ VAT)</label>
            <div class="value">{{translateValue(ProjectBasicInformation.digital)}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Opex CR</label>
            <div class="value">{{ProjectBasicInformation.opexCRNO}}</div>
          </div>
          <div class="d-flex">
            <label class="label">Status</label>
            <div class="value">{{ProjectBasicInformation.opexCRStatus}}</div>
          </div>
          <div class="d-flex">
            <label class="label" style="width:35%;">Opex Total(w/ VAT)</label>
            <div class="value">{{translateValue(parseFloat(ProjectBasicInformation.opex))}}</div>
          </div>
          <div class="d-flex">
            <label class="label"></label>
            <div class="value"></div>
          </div>
          <div class="d-flex">
            <label class="label"></label>
            <div class="value"></div>
          </div>
          <div class="d-flex">
            <label class="label" style="width:35%;">Grand Total(w/ VAT)</label>
            <div class="value">{{translateValue(parseFloat(ProjectBasicInformation.grandTotal))}}</div>
          </div>
        </div>
      </div>
      <div class="d-flex d-flex-first d-tabs">
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleClick"
          :stretch="true"
          style="width: 100%; margin-bottom: 80px"
        >
          <el-tab-pane label="Capex" name="1">
            <div class="cr-table">
              <!-- <div class="div-pagination">
                <el-pagination
                  background
                  @current-change="pagingChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="currentPage"
                  :page-size="pagenum"
                  100, 200]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  ref="multipleTable"
                ></el-pagination>
              </div>-->
              <div class="table" ref="table">
                <el-table
                  ref="multipleTable"
                  v-loading="loading"
                  :data="tableData"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                  border
                  fit
                  tooltip-effect="dark"
                >
                  <template>
                    <el-table-column
                      :prop="item.value"
                      :label="item.label"
                      v-for="(item, index) in tableColumn"
                      :key="index"
                      :width="item.width"
                      show-overflow-tooltip                      
                    >
                      <el-table-column
                        :prop="domain.value"
                        :label="domain.label"
                        v-for="(domain, domainIndex) in item.child"
                        :key="domainIndex"
                        :width="domain.width"
                        show-overflow-tooltip
                        :formatter="rounding"
                      ></el-table-column>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Opex" name="2">
            <div class="cr-table">
              <!-- <div class="div-pagination">
                <el-pagination
                  background
                  @current-change="pagingChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="currentPage"
                  :page-size="pagenum"
                  :page-sizes="[20, 50, 100, 200]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  ref="multipleTable"
                ></el-pagination>
              </div>-->
              <div class="table" ref="table">
                <el-table
                  ref="multipleTable"
                  v-loading="loading"
                  :data="tableData2"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                  border
                  fit
                  tooltip-effect="dark"
                >
                  <template>
                    <el-table-column
                      :prop="item.value"
                      :label="item.label"
                      v-for="(item, index) in tableColumn"
                      :key="index"
                      :width="item.width"
                      show-overflow-tooltip
                    >
                      <el-table-column
                        :prop="domain.value"
                        :label="domain.label"
                        v-for="(domain, domainIndex) in item.child"
                        :key="domainIndex"
                        :width="domain.width"
                        show-overflow-tooltip
                        :formatter="rounding"
                      ></el-table-column>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Digital" name="3">
            <div class="cr-table">              
              <div class="table" ref="table">
                <el-table
                  ref="multipleTable"
                  v-loading="loading"
                  :data="tableData3"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                  border
                  fit
                  tooltip-effect="dark"
                >
                  <template>
                    <el-table-column
                      :prop="item.value"
                      :label="item.label"
                      v-for="(item, index) in tableColumn"
                      :key="index"
                      :width="item.width"
                      show-overflow-tooltip
                    >
                      <el-table-column
                        :prop="domain.value"
                        :label="domain.label"
                        v-for="(domain, domainIndex) in item.child"
                        :key="domainIndex"
                        :width="domain.width"
                        show-overflow-tooltip
                        :formatter="rounding"
                      ></el-table-column>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
            </div>

          </el-tab-pane>
          <el-tab-pane label="HQ CR" name="4">HQ CR</el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableColumn: [
        {
          label: "Category Name",
          value: "categoryName",
          width: "260px"
        },
        {
          label: "CR Amount",
          value: "CRAmount",
          width: "auto",
          child: [
            {
              label: "w/ VAT",
              value: "cost_inclVATRate",
              width: "auto"
            },
            {
              label: "w/o VAT",
              value: "cost_exclVATRate",
              width: "auto"
            }
          ]
        },
        {
          label: "Quotation",
          value: "Quotation",
          width: "auto",
          child: [
            {
              label: "w/ VAT",
              value: "quotationAmountInclVAT",
              width: "auto"
            },
            {
              label: "w/o VAT",
              value: "quotationAmountExclVAT",
              width: "auto"
            }
          ]
        }
      ],
      total: 100,
      loading: false,
      currentPage: 1,
      pagenum: 20,
      tableHeight: window.innerHeight - 190,
      spanArr: [],
      activeName: "1",
      ProjectBasicInformation: {
        action: "",
        address: "",
        appDate: "",
        application: 0,
        capex: "",
        channel: "",
        cityCN: "",
        cityEN: "",
        format: "",
        groupCustomer: 0,
        groupCustomerName: "",
        opex: "",
        posCode: "",
        posFullNameCN: "",
        projectCode: "",
        projectStatus: "",
        provinceCN: "",
        provinceEN: "",
        region: "",
        requestOpenDate: "",
        subChannel: "",
        team: "",
        opexCRNO:"",
        digitalCRNO:"",
        capexCRNO:"",
        capexCRStatus:"",
        opexCRStatus:"",
        digitalCRStatus:""		
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    tableHeaderCell({ column }) {
      return "background: #FFEDD1;color: #5A5854;text-align: center;border:1px solid #fff";
    },
    tableCell({ column }) {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    // pagingChange(pageIndex) {
    //   this.BindData(pageIndex);
    // },
    // handleSizeChange(val) {
    //   this.pagenum = val;
    //   this.BindData(this.currentPage);
    // },
    BindData() {
      this.$api
        .get("/CR/GetBigTableDetail", {
          application: this.$route.params.id
        })
        .then(res => {
          // console.log(res);
          if (res.data.status) {
            if (res.data.content.length > 0) {
              this.ProjectBasicInformation = res.data.content[0];
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    BindCRDataBaseDetail() {
      this.$api
        .get("/CR/GetCRDataBaseDetail", {
          Id: this.$route.params.id
        })
        .then(res => {
          if (res.data.status) {
            if (res.data.content.length > 0) {
              this.tableData = res.data.content.filter(a=>a.sub_XPEX=="Capex");
              this.tableData2 = res.data.content.filter(a=>a.sub_XPEX=="Opex");
              this.tableData3 = res.data.content.filter(a=>a.sub_XPEX=="Digital");
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    Init() {
      this.BindData(1);
      this.BindCRDataBaseDetail();
    },
    transferToDecimal(cellvalues) {
      if (!!cellvalues) {
        if (typeof(cellvalues)=="number") {
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        }
      } else {
        return cellvalues;
      }
    },
    setdates(arr) {
      var obj = {},
        k;
      this.spanArr = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        k = arr[i].Sub_XPEX; //需要合并的字段
        if (obj[k]) obj[k]++;
        else obj[k] = 1;
      }
      // console.log(obj);
      //保存结果{el-'元素'，count-出现次数}
      for (var o in obj) {
        for (let i = 0; i < obj[o]; i++) {
          if (i === 0) {
            this.spanArr.push(obj[o]);
          } else {
            this.spanArr.push(0);
          }
        }
      }
      // console.log(this.spanArr);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        let _row = this.spanArr[rowIndex];
        let _col = this.spanArr[rowIndex] > 0 ? 1 : 0;
        return [_row, _col];
      }
    },
    formateDate(datetime) {
      if (!(datetime == "" || datetime == null || datetime == undefined)) {
        function addDateZero(num) {
          return num < 10 ? "0" + num : num;
        }
        let d = new Date(datetime);
        let formatdatetime =
          d.getFullYear() +
          "-" +
          addDateZero(d.getMonth() + 1) +
          "-" +
          addDateZero(d.getDate());
        return formatdatetime;
      }
    },
    translateValue(value) {
      //if (!!value) {
        //return value.toFixed(2);
        if (typeof(value)=="number") {
        value = parseFloat(value).toFixed(2);
        let [sInt, sFloat] = value.toString().split(".");
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
        return (value = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        //}
      } else {
        return value;
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    rounding(row,column){
      let cellvalues = row[column.property];
      if (typeof(cellvalues)=="number") {
        cellvalues = parseFloat(cellvalues).toFixed(2);
        let [sInt, sFloat] = cellvalues.toString().split(".");
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
        return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
      }
      else
        return row[column.property];
    }
  },
  mounted() {
    this.setdates(this.tableData);
    this.Init();
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.d-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin: auto;
  width: 94%;
  &.d-flex-first {
    margin-top: 30px;
    min-height: 100px;
  }
  &.d-tabs {
    width: 100%;
    .d-row {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #e6a23c;
      border-bottom: none;
      width: 100%;
      margin-bottom: 20px;
      .d-flex {
        width: 33.33%;
        display: flex;
        align-items: center;
        margin: 0;
        height: 36px;
        font-size: 14px;
        text-align: left;
        box-sizing: border-box;
        border-right: 1px solid #e6a23c;
        border-bottom: 1px solid #e6a23c;
        &:nth-child(3n) {
          border-right: none;
        }
        .label {
          padding-right: 10px;
          padding-left: 2px;
          min-width: 35%;
          height: 36px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          border-bottom: 1px solid #e6a23c;
          border-right: 1px solid #e6a23c;
          background: #fee7c5;
          box-sizing: border-box;
        }
        .value {
          flex: 1;
          text-align: left;
          height: 36px;
          display: flex;
          align-items: center;
          padding-left: 10px;
        }
      }
    }
  }
  .flex-item {
    width: 25%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 10px;

    overflow: hidden;
    margin-bottom: 15px;
    .label {
      padding-right: 5px;
      min-width: 120px;
      text-align: right;
    }
    &:nth-child(4n-3) {
      padding-left: 0;
    }
  }
}
.content_title {
  margin: 20px auto 0;
  width: 90%;
  text-align: left;
  .basic-information {
    line-height: 42px;
    font-size: 18px;
  }
  .CR-btn {
    display: flex;
    justify-content: end;
    .button-search {
      background-color: #e6a23c;
      border: 0px #e6a23c;
      color: #ffff;
    }
  }
}
.cr-table {
  width: 100%;

  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CRDataBaseDetail.vue